
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface AddExamButtonProps {
  studentId: number | string;
}

const AddExamButton = ({ studentId }: AddExamButtonProps) => {
  const navigate = useNavigate();
  
  const handleAddExam = () => {
    navigate(`/students/${studentId}/exams/new`);
  };
  
  return (
    <Button onClick={handleAddExam} variant="default" className="gap-2">
      <Plus className="h-4 w-4" />
      <span>Add New Result</span>
    </Button>
  );
};

export default AddExamButton;
